"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var Modal_1 = __importDefault(require("../../../../common/Modal/Modal"));
var Spinner_1 = __importDefault(require("../../../../common/Spinner/Spinner"));
var TextInput_1 = __importDefault(require("../../../../common/TextInput/TextInput"));
var Toast_1 = require("../../../../common/Toast");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var icons_1 = __importDefault(require("../../../../theme/icons"));
var SortingSelector_1 = __importDefault(require("../../Knowledge/Selectors/SortingSelector"));
var Mutation_1 = require("../Graphql/Mutation");
var ServiceCategoryTable_1 = __importDefault(require("./ServiceCategoryTable"));
var ServiceCategory = function (_a) {
    var catList = _a.catList, loading = _a.loading, onCatSave = _a.onCatSave;
    var organization = (0, org_hook_1.useOrg)().organization, _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n, _c = (0, react_1.useState)([
        {
            id: null,
            name: {},
            sorting: null,
            organization_id: null,
        },
    ]), fields = _c[0], setFields = _c[1], _d = (0, react_1.useState)([]), error = _d[0], setError = _d[1];
    var _e = (0, react_1.useState)({ en: "", fr: "", rn: "" }), languages = _e[0], setLanguages = _e[1];
    var _f = (0, client_1.useMutation)(Mutation_1.DELETE_SERVICE_CATEGORY, {
        fetchPolicy: "network-only",
        refetchQueries: ["getAllServiceCategoriesByOrganization"],
    }), callDeleteServiceCategory = _f[0], responseDeleteServiceCategory = _f[1];
    var resetForm = function () {
        setFields([
            {
                id: null,
                name: {
                    en: "",
                    fr: "",
                    rn: "",
                },
                sorting: null,
                organization_id: organization.id,
            },
        ]);
    };
    function handleChange(i, value, type) {
        setError([]);
        var values = __spreadArray([], fields, true);
        values[i]["organization_id"] = organization.id;
        if (type === "name") {
            values[i][type][i18n.language] = value;
        }
        else if (type === "sorting") {
            values[i][type] = value;
        }
        setFields(values);
    }
    var triggerButton = function () { return (react_1.default.createElement("div", { style: { top: "8.3rem" } },
        react_1.default.createElement(Button_1.default, { className: "form-buttom", icon: react_1.default.createElement(icons_1.default, { name: "plus", className: "icon", height: 30, width: 30 }), text: t("add_service_category") }))); };
    var createUI = function () { return (react_1.default.createElement(react_1.default.Fragment, null, fields.map(function (item, idx) {
        var _a;
        var findIndex = error.length > 0 &&
            error.find(function (i) { return i.index === idx; });
        return (react_1.default.createElement("div", { className: "inner-content", key: idx },
            react_1.default.createElement(TextInput_1.default, { error: findIndex &&
                    findIndex.index === idx &&
                    findIndex.type === "name" &&
                    findIndex.message, label: t("name"), onChange: function (e) { return handleChange(idx, e.target.value, "name"); }, value: ((_a = item === null || item === void 0 ? void 0 : item.name) === null || _a === void 0 ? void 0 : _a[i18n.language]) || "" }),
            react_1.default.createElement(SortingSelector_1.default, { list: catList || [], onChange: function (e) {
                    handleChange(idx, e.sorting_id, "sorting");
                }, value: item.sorting })));
    }))); };
    var onSaveClick = function () {
        var tmp = [], errortmp = [];
        fields.map(function (l, i) {
            if (l.name[i18n.language] === "") {
                errortmp.push({
                    type: "name",
                    message: "required",
                    index: i,
                });
            }
            else {
                var id = l.id, name_1 = JSON.stringify(l.name), sorting = l.sorting ? parseInt(l.sorting) : null;
                tmp.push({
                    id: id,
                    name: name_1,
                    sorting: sorting,
                    organization_id: organization.id,
                });
            }
        });
        if (tmp.length === fields.length && tmp.length > 0) {
            onCatSave(tmp);
            resetForm();
        }
        else {
            setError(errortmp);
        }
    };
    var onEditClick = function (item) {
        var parsedName = JSON.parse(item.name);
        setFields([
            {
                id: item.id,
                name: parsedName,
                sorting: item.sorting,
                organization_id: item.organization_id,
            },
        ]);
    };
    var onDeleteClick = function (item) {
        callDeleteServiceCategory({
            variables: {
                id: item.id,
                organization_id: item.organization_id,
            },
        });
        resetForm();
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        (loading || (responseDeleteServiceCategory === null || responseDeleteServiceCategory === void 0 ? void 0 : responseDeleteServiceCategory.loading)) && react_1.default.createElement(Spinner_1.default, null),
        (responseDeleteServiceCategory === null || responseDeleteServiceCategory === void 0 ? void 0 : responseDeleteServiceCategory.data) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t("deleted_successfully"), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        react_1.default.createElement(Modal_1.default, { onCloseClick: function () {
                resetForm();
            }, onSaveClick: function () { return onSaveClick(); }, title: "add_service_category", triggerButton: triggerButton },
            createUI(),
            react_1.default.createElement(ServiceCategoryTable_1.default, { list: catList, languages: languages, onDeleteClick: onDeleteClick, onEditClick: onEditClick }))));
};
exports.default = ServiceCategory;
